// apiService.ts.
import axios from 'axios';
import { API_BASE_URL } from './config';
import { CustomReponse, CustomTask, DataResponse, Item, Workpack, EmailOption } from './helper';

export const fetchSitesData = async (): Promise<Item[]> => {
    try {
        const response = await axios.get(`${API_BASE_URL}/ermeo/sites`);
        return response.data;
    } catch (error) {
        console.error('Error fetching project list:', error);
        throw error;
    }
};


export const fetchProjectsData = async (site_id: string): Promise<Item[]> => {
    try {
        const response = await axios.get(`${API_BASE_URL}/ermeo/projects/${site_id}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching dropdown data:', error);
        throw error;
    }
};

export const fetchWorkpackData = async (project_id: string): Promise<Item[]> => {
    try {
        const response = await axios.get(`${API_BASE_URL}/ermeo/workpacks/${project_id}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching dropdown data:', error);
        throw error;
    }
};

export const rebaselineWorkpackData = async (wpId: string): Promise<Workpack> => {
    try {
        const response = await axios.get(`${API_BASE_URL}/ermeo/rebaseline/${wpId}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching dropdown data:', error);
        throw error;
    }
};

export const fetchTaskChartData = async (parentId: string, timeFrame: string): Promise<DataResponse> => {
    try {
        const response = await axios.get(`${API_BASE_URL}/ermeo/task-chart-data/${parentId}`, {
            params: { time_frame: timeFrame },
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching chart data:', error);
        throw error;
    }
};
export const fetchSiteChartData = async (parentId: string, timeFrame: string): Promise<DataResponse> => {
    try {
        const response = await axios.get(`${API_BASE_URL}/ermeo/site-chart-data/${parentId}`, {
            params: { time_frame: timeFrame },
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching chart data:', error);
        throw error;
    }
};

export const fetchTasks = async (wpId: string): Promise<CustomReponse> => {
    try {
        const response = await axios.get(`${API_BASE_URL}/ermeo/tasks/${wpId}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching tasks:', error);
        throw error;
    }
};

export const updateTaskWithProgress = async (taskData: { start_date?: any; end_date?: any; parent?: string; id: string; progress: number; is_locked?: boolean }): Promise<void> => {
    try {
        await axios.patch(`${API_BASE_URL}/ermeo/updatetask/${taskData.id}`, taskData);
    } catch (error) {
        console.error('Error updating task with progress:', error);
        throw error;
    }
};


export const getEmails = async (): Promise<EmailOption[]> => {
    try {
        const res = await axios.post(`${API_BASE_URL}/ermeo/get-email`)
        return res.data
    }catch (error) {
        console.error('Error Fetching the Emails', error);
        throw error;
    }
};


export const updateTaskReorder = async (orderData : { op_no: number; id: string; }) => {
  try {
    const response = await axios.patch(`${API_BASE_URL}/ermeo/reorder-task/${orderData.id}`, orderData);
    return response.data;
  } catch (error) {
    console.error('Error updating task reorder:', error);
    throw error;
  }
};

export const verifyProgressPassword = async (password: string): Promise<boolean> => {
  try {
    const response = await axios.post(`${API_BASE_URL}/ermeo/verify-progress-password`, {
      password,
    });
    return Boolean(response.data?.is_valid);
  } catch (error) {
    console.error('Error verifying progress password:', error);
    throw error;
  }
};